module.exports = __webpack_public_path__ + "static/media/alert-white.4411e8eb.svg";